const isDev = import.meta.env.DEV;
const isQA = import.meta.env.VITE_DEPLOYMENT === 'staging';

const SERVER_URL = isDev
  ? 'http://localhost:1342'
  : isQA
    ? 'https://dev-server.thegarden.gg'
    : 'https://server.thegarden.gg';

export { SERVER_URL };
